import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import { 
  loadCategories,
  removeCategory,
} from '../../reducers/categories';

class Categories extends Component {

  componentWillReceiveProps = () => {
  }

  removeCategory = (category) => {
    if(window.confirm(`Do you want to remove ${category.category_name}?`)){
      this.props.removeCategory(category.category_id);
    }
  }

  render() {
    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>Categories</PageTitle>
          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">

              <div className="input-group col-md-4">
                {/* <input type="text" className="form-control" aria-label="Text input with dropdown button" placeholder="Search Categories" /> */}
              </div>

              <div className="col-md-4 offset-md-4">
                <Link to="/categories/add" className="btn btn-primary float-right">Add Category</Link>
              </div>

            </div>
            
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">Category</th>
                  <th scope="col" width="200">Actions</th>
                </tr>
              </thead>
              {this.props.isLoadingCategories &&
                <tbody>
                  <tr>
                    <td colSpan="2" className="text-center"><em>Loading Categories</em></td>
                  </tr>
                </tbody>
              }
              {!this.props.isLoadingCategories && this.props.categories.length === 0 &&
                <tbody>
                  <tr>
                    <td colSpan="2" className="text-center"><em>0 Categories</em></td>
                  </tr>
                </tbody>
              }
              {this.props.categories &&
                <tbody>
                  {this.props.categories.map((category, idx) => {
                    return (
                      <tr key={`store-${idx}`}>
                        <th>{category.category_name}</th>
                        <td>
                          <Link to={`/categories/${category.category_id}`} className="btn btn-outline-secondary btn-sm">Edit</Link>&nbsp;
                          <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeCategory(category)}>Remove</button>&nbsp;
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              }
            </table>
          </div>
        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  categories: state.categories.categories,
  isLoadingCategories: state.categories.isLoadingCategories
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadCategories,
      removeCategory,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Categories);


// WEBPACK FOOTER //
// ./src/modules/Categories/Categories.js